// eslint-disable-next-line import/no-unresolved
import { init } from 'sentry-alias';
import { union } from 'lodash';
import config from 'lib/config';

// these are a bunch of common errors that sentry recommends ignoring:
// https://docs.sentry.io/clients/javascript/tips/
const commonErrors = [
  'top.GLOBALS',
  'originalCreateNotification',
  'canvas.contentDocument',
  'MyApp_RemoveAllHighlights',
  'http://tt.epicplay.com',
  "Can't find variable: ZiteReader",
  'jigsaw is not defined',
  'ComboSearch is not defined',
  'http://loading.retry.widdit.com/',
  'atomicFindClose',
  'fb_xd_fragment',
  'bmi_SafeAddOnload',
  'EBCallBackMessageReceived',
  'conduitPage',
];

// these errors are specific to autolist and we think are related to ads
const adsErrors = [
  'NS_ERROR_NOT_INITIALIZED',
  'setTimeout(u,e)',
  'clearTimeout(f)',
  "Object is not a function. (In 'Object(t)', 'Object' is undefined)",
  /^Error Object expected http/,
];

// other errors that are specific to autolist but we want to ignore them
const miscErrors = [
  // Firebase throws these errors when there are network connection issues
  'Network Error',
  'A network error (such as timeout, interrupted connection or unreachable host) has occurred.',
];

const ignoreErrors = union(commonErrors, adsErrors, miscErrors);

const whitelistUrls = [
  /autolist-web-.*\.herokuapp\.com/,
  /experimental\.autolist\.com/,
  /sentry\.io/,
  /getsentry\.com/,
  /cdn\.getsentry\.com/,
  /www\.autolist\.com/,
  /autolist\.com/,
  /.*-proxy\.autolist\.com/,
  /googlemaps\.autolist\.com/,
  /production-assets\d+\.autolist\.com/,
];

// This needs to be exported as part of a module/object in order to stub
// with mock functions (see _app.test.js)
// eslint-disable-next-line import/prefer-default-export
export function initialize(): void {
  if (config.nodeEnv === 'development') {
    return;
  }

  const sentryConfig = {
    environment: config.customEnv,
    ignoreErrors,
    whitelistUrls,
    release: config.imageTag,
    dsn: config.ravenJsDsn,
  };

  init(sentryConfig);
}
